const URL_BASE = 'http://localhost';

export const isMenuRouteActive = (currentPath, menuPath) => {
    const currentUrl = new URL(currentPath, URL_BASE);
    const menuUrl = new URL(menuPath, URL_BASE);

    return (
        currentUrl.pathname === menuUrl.pathname &&
        Array.from(menuUrl.searchParams).every(([key, value]) =>
            currentUrl.searchParams.getAll(key).includes(value)
        )
    );
};
